import { ThemeExtension } from '@liscio/ui';

/**
 * Sometimes for firm for user experience consistency we will want to mimic the desktop theme in refactor
 **/
export const refactorComponents: ThemeExtension = (theme) => ({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.875rem',
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(1),
          display: 'block',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          // Only apply bold to labels that are NOT for checkboxes/radios/switches
          '&:not(:has(.MuiCheckbox-root)):not(:has(.MuiRadio-root)):not(:has(.MuiSwitch-root))':
            {
              '& .MuiFormControlLabel-label': {
                fontWeight: 600,
                fontSize: '0.875rem',
              },
            },
        },
      },
    },
  },
});
